<template>
    <div v-if="!hide" class="form-network form-network-linkedin" >
        <details open>
            <summary>{{ $t('dash.post-creator.form.linkedin.visibility') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <SelectComponent
                    :valueSelect="draftInstance.form.networks.linkedin.visibility"
                    :changeValueSelect="changeVisibilityPost"
                    :data="{
                        PUBLIC:$t('dash.post-creator.form.linkedin.visibility-public'),
                        CONNECTIONS:$t('dash.post-creator.form.linkedin.visibility-connections'),
                        LOGGED_IN:$t('dash.post-creator.form.linkedin.visibility-members')
                    }"
                    :positionAuto="false"
                    :positionX="'left'"
                />

                <div class="type-switch">
                    <span class="label-beta">
                        {{ $t('dash.post-creator.form.linkedin.audience-targeting') }}
                        <span class="tag-beta">Beta</span>
                    </span>
                    <ComponentSwitch :value="audienceTargeting" :onChange="(v) => audienceTargeting = v" :id="'switch-settings-advanced-linkedin-3'"></ComponentSwitch>
                </div>
            </div>
        </details>

        <details open>
            <summary>{{ $t('dash.post-creator.form.linkedin.survey') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="type-switch">
                    {{ $t('dash.post-creator.form.linkedin.add-survey') }}
                    <ComponentSwitch :value="draftInstance.form.networks.linkedin.survey.active" :onChange="draftInstance.form.networks.linkedin.survey.setActive" :id="'switch-settings-advanced-linkedin-1'"></ComponentSwitch>
                </div>

                <div class="form-sondage" v-if="draftInstance.form.networks.linkedin.survey.active" >
                    <SelectComponent 
                        :changeValueSelect="changeDurationSurvey" 
                        :data="{
                            oneDay:$t('dash.post-creator.form.linkedin.survey-duration-1day'),
                            threeDay:$t('dash.post-creator.form.linkedin.survey-duration-3days'),
                            oneWeek:$t('dash.post-creator.form.linkedin.survey-duration-1week'),
                            twoWeek:$t('dash.post-creator.form.linkedin.survey-duration-2weeks')
                        }"
                        :valueSelect="draftInstance.form.networks.linkedin.survey.duration" 
                        :positionAuto="false" 
                        :positionX="'left'"
                    />

                    <div class="type-input">
                        <i class="fa-regular fa-circle-question"></i>
                        <input :placeholder="$t('dash.post-creator.form.linkedin.survey-question')" v-model="draftInstance.form.networks.linkedin.survey.question" maxlength="140"/>
                    </div>

                    <div class="list-question">
                        <div class="type-input">
                            <input :placeholder="$t('dash.post-creator.form.linkedin.survey-option', { n: 1 })" v-model="draftInstance.form.networks.linkedin.survey.options[0]" maxlength="30"/>
                        </div>
                        <div class="type-input">
                            <input :placeholder="$t('dash.post-creator.form.linkedin.survey-option', { n: 2 })" v-model="draftInstance.form.networks.linkedin.survey.options[1]" maxlength="30"/>
                        </div>
                        <div class="type-input" v-if="draftInstance.form.networks.linkedin.survey.options.length >= 3">
                            <input :placeholder="$t('dash.post-creator.form.linkedin.survey-option', { n: 3 })" v-model="draftInstance.form.networks.linkedin.survey.options[2]" maxlength="30"/>
                            <i class="fa-regular fa-square-minus" @click="()=>removeOptionSurvey(2)"></i>
                        </div>

                        <div class="type-input" v-if="draftInstance.form.networks.linkedin.survey.options.length == 4">
                            <input :placeholder="$t('dash.post-creator.form.linkedin.survey-option', { n: 4 })" v-model="draftInstance.form.networks.linkedin.survey.options[3]" maxlength="30"/>
                            <i class="fa-regular fa-square-minus" @click="()=>removeOptionSurvey(3)"></i>
                        </div>

                        <div class="btn-add" v-if="draftInstance.form.networks.linkedin.survey.options.length < 4" @click="addOptionSurvey">
                            <p>{{ $t('dash.post-creator.form.linkedin.add-option') }}</p>
                            <i class="fa-solid fa-plus"></i>
                        </div>  
                    </div>          
                </div>
                
            </div>      
        </details>
        <!-- <details v-if="formDataNetwork.typeMedia =='pdf'" open>
            <summary>Document Pdf <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="type-input">
                    <i class="fa-solid fa-pen-to-square"></i>
                    <input placeholder="Titre par default" v-model="formDataNetwork.pdf.title">
                </div>
            </div>      
        </details> -->
 
        <details v-if="!draftInstance.form.networks.linkedin.survey.active && draftInstance.form.urlsTextContentHistory.length" open>
            <summary>
                {{ $t('dash.post-creator.form.linkedin.link-preview') }} 
                <i class="fa-solid fa-caret-down"></i>
            </summary>

            <div class="content-detail form-link">
                <div class="list-thubmmail">
                    
    
                    <div class="thubmmail" v-for="(url) in draftInstance.form.urlsTextContentHistory" @click="()=>selectUrl(url.value)" :key="url">
                        

                        <Checkbox :id="url" :prefixId="'thubmmail-'" 
                            :isChecked="(draftInstance.form.networks.linkedin.snippet.link == url.value)" 
                            :isDisable="(draftInstance.form.networks.linkedin.snippet.link == url.value)"
                            :add="() => selectUrl(url.value)" :remove="()=>{}"
                        />
                        <SnippetNetwork 
                            :link="url.value"
                            :isDisable="(draftInstance.form.networks.linkedin.snippet.link == url.value)"
                            :imageUrlDefault="draftInstance.form.networks.linkedin.snippet.customActived && draftInstance.form.networks.linkedin.snippet.image && draftInstance.form.networks.linkedin.snippet.image.id && draftInstance.files.getById(draftInstance.form.networks.linkedin.snippet.image.id).isUpload ? draftInstance.files.getById(draftInstance.form.networks.linkedin.snippet.image.id).url : undefined" 
                            :titleDefault="draftInstance.form.networks.linkedin.snippet.customActived && draftInstance.form.networks.linkedin.snippet.title"
                        />
                    </div>
                </div>
    
                <div class="type-switch"  v-if="draftInstance.form.urlsTextContentHistory.length">
                    {{ $t('dash.post-creator.form.linkedin.link-preview-edit') }}
                    <ComponentSwitch :value="draftInstance.form.networks.linkedin.snippet.customActived" :onChange="(v) => switchCustomSnippetChange(v)" :id="'switch-settings-advanced-linkedin-2'"></ComponentSwitch>

                </div>
            
                <template v-if="draftInstance.form.networks.linkedin.snippet.customActived && (draftInstance.form.urlsTextContentHistory.length)">
                    <input
                        v-validate="''"
                        name="file"
                        type="file"
                        id="file"
                        ref="inputImageSnippet"
                        @change="selectImageSnippet"
                        :multiple="false"
                        @click="()=>{}"
                        :accept="`image/*`"
                        hidden
                    >

                    <div class="type-btn-add" @click="toggleAddImage">
                        <i class="fa-solid fa-image"></i>
                        <template v-if="
                            draftInstance.form.networks.linkedin.snippet.image && 
                            draftInstance.form.networks.linkedin.snippet.title.id && 
                            draftInstance.files.getById(draftInstance.form.networks.linkedin.snippet.image.id) &&
                            draftInstance.files.getById(draftInstance.form.networks.linkedin.snippet.image.id).isUploading
                        ">
                            {{ $t('dash.post-creator.form.linkedin.media-uploading') }}
                        </template>
                        <template v-else-if="
                            draftInstance.form.networks.linkedin.snippet.image && 
                            draftInstance.form.networks.linkedin.snippet.image.id && 
                            draftInstance.files.getById(draftInstance.form.networks.linkedin.snippet.image.id) && 
                            draftInstance.files.getById(draftInstance.form.networks.linkedin.snippet.image.id).isUpload
                        ">
                            {{draftInstance.files.getById(draftInstance.form.networks.linkedin.snippet.image.id).info.name}}
                             <i class="fa-regular fa-square-minus"></i>
                        </template>
                        <template v-else>
                            {{ $t('dash.post-creator.form.linkedin.add-image') }}
                            <i class="fa-solid fa-plus"></i>
                        </template>
                        
                       
                    </div>
                    <div class="type-input">
                        <i class="fa-solid fa-pen-to-square"></i>
                        <input placeholder="Titre par default" v-model="draftInstance.form.networks.linkedin.snippet.title">
                        <i class="fa-regular fa-square-minus" v-if="draftInstance.form.networks.linkedin.snippet.title" @click="()=> draftInstance.form.networks.linkedin.snippet.title =''"></i>
                    </div>
                </template>
            </div>
            
        </details>
   </div>
</template>

<script>
   import { EventBus } from '@/event-bus';
   import store from '@/store/index.js';
   import ComponentSwitch from '@/components/dash/utils/switch.vue'
   import SelectComponent from '@/components/dash/utils/select.vue'
   import SnippetNetwork from './../SnippetNetwork.vue'
   import minxinBot from '@/components/mixins/Bots.vue'
   import minxinPost from '@/components/mixins/Posts.vue'
   import Checkbox from '@/components/dash/utils/checkbox.vue'
   import { getFilesByNetwork } from './../../../utils'
   import { VueDraft } from '@mashupweb/draft-lib'
   export default {

       components: {
           ComponentSwitch,
           SelectComponent,
           SnippetNetwork,
           Checkbox
       },
       mixins: [minxinBot,minxinPost],

       props: {
            hide : {
                type: Boolean,
                default: false
            },

            files:Object,

            personalizationMode : {
                type: Boolean,
                default: false
            },
            idPageRenderNetworkSelected: String,
            typeRenderNetworkSelected: String,
            draftInstance:VueDraft

       },

       data() {
           return {
                inputModel:{
                    urlImageSnippet: "",
                    titleSnippet: "",
                    descriptionSnippet: "",
                },

                lastModeSelected : undefined,

                //temporaire : à brancher sur draftInstance.form.networks.linkedin quand la lib sera à jour
                audienceTargeting: false
           }
       },

       

       methods: {
            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },

            addOptionSurvey() {
                this.draftInstance.form.networks.linkedin.survey.options = [...this.draftInstance.form.networks.linkedin.survey.options, ''].slice(0,4)
            },

            removeOptionSurvey(index) {
                this.draftInstance.form.networks.linkedin.survey.options = this.draftInstance.form.networks.linkedin.survey.options.filter((o,i) => i !== index)
            },

            changeVisibilityPost(state) {
                this.draftInstance.form.networks.linkedin.visibility = state
            },

            changeDurationSurvey(duration) {
                this.draftInstance.form.networks.linkedin.survey.duration = duration
            },

            switchCustomSnippetChange(v) {
                this.draftInstance.form.networks.linkedin.snippet.customActived = v
            },
           
            selectUrl(url) {
                if (this.draftInstance.form.networks.linkedin.snippet.link == url) {
                    this.draftInstance.form.networks.linkedin.snippet.unselect()
                }else{
                    this.draftInstance.form.networks.linkedin.snippet.select(url)
                }
            },

            // verifUrlSelected(urlsTextContentHistory = []) {
             
            //     urlsTextContentHistory = this.draftInstance.form.urlsTextContentHistory

            //     if (urlsTextContentHistory.length) {
            //         let linkSelect = this.draftInstance.form.networks.linkedin?.snippet?.link

            //         if (!linkSelect) {
            //             const files = getFilesByNetwork(this.formData.files, ['linkedin'], {['linkedin']: this.formData.formDataNetwork['linkedin']}, this.files, true)['linkedin']
            //             if (!files || !files.length) {
            //                 this.selectUrl(urlsTextContentHistory[0])
            //             }
            //         }else if (!urlsTextContentHistory.includes(linkSelect)) {
            //             this.selectUrl(urlsTextContentHistory[0])
            //         }
            //     }else{
            //         this.selectUrl('')
            //     }
             
            // },

            toggleAddImage() {
                if (this.draftInstance.form.networks.linkedin.snippet.image) {
                    this.draftInstance.form.networks.linkedin.snippet.image = undefined
                }else{
                    this.$refs.inputImageSnippet.click()
                }
            },

            selectImageSnippet(e) {
                this.draftInstance.form.networks.linkedin.snippet.uploadImage(e.target.files[0])
            }
       },

       computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },

            //temporaire
            conciergeriePagesIsActive() {
                const pagesLinkedin = this.pagesSelected.filter(page => page.network == 'linkedin')
                const isActive = (page) => {
                    return (page.network == 'linkedin' && page.story_config && page.story_config.created)

                }
                if (!this.personalizationMode || !this.idPageRenderNetworkSelected) {
                    return pagesLinkedin.every(page => isActive(page))
                }else{
                    return isActive(this.allPages[this.idPageRenderNetworkSelected])
                }
            },
       },

       watch: {
     
            conciergeriePagesIsActive: {
                immediate: true,
                handler(newValue, oldValue) {
         
                }
            }
       },


       beforeDestroy () {
         
       }
       
   }
</script>